import React from 'react';
import { Box, Typography, Link, Divider } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import { DomId } from 'constants/DomId';

import { IHelpSection } from '../models';
import HelpTags from '../HelpTags';

import messages from './messages';

interface IProps {
  section: IHelpSection;
}

const HelpSection = ({ section }: IProps) => {
  return (
    <Box id={section.hash} padding='75px 0px'>
      <Box display='flex' alignItems='center'>
        <Typography variant='h5'>{section.label}</Typography>
        <HelpTags section={section} />
        <Link
          sx={{ fontSize: '.85rem', marginLeft: '10px', marginTop: '5px' }}
          component={RouterLink}
          to={`#${DomId.HelpTop}`}
        >
          <FormattedMessage {...messages.topLinkText} />
        </Link>
      </Box>
      <Box margin='15px'>{section.content}</Box>
      <Divider />
    </Box>
  );
};

export default HelpSection;
